import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToCTA = () => {
    document.getElementById('cta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[85vh] flex items-center bg-white overflow-hidden py-12 md:py-20" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-145">
          <div className="order-2 lg:order-1" data-id="element-146">
            <span className="inline-block px-4 py-1.5 rounded-full bg-[#DBEAFE] text-[#1e3a8a] font-semibold text-sm mb-6 tracking-wide" data-id="element-147">
              MÉTODO 3–3–7
            </span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#1F2937] leading-tight mb-6" data-id="element-148">
              No te falta disciplina: <br data-id="element-149" />
              <span className="text-[#1e3a8a]" data-id="element-150">
                te faltan menos decisiones.
              </span>
            </h1>
            <p className="text-lg md:text-xl text-[#4B5563] mb-8 leading-relaxed max-w-lg" data-id="element-151">
              Cocina para tu "día malo" y por fin funciona. Un sistema flexible
              para mujeres con la mente saturada.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 items-start" data-id="element-152">
              <Button onClick={scrollToCTA} data-id="element-153">Más Información</Button>
              <p className="text-sm text-[#6B7280] italic" data-id="element-154">
                *Sin recetas complicadas
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative" data-id="element-155">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-[#1e3a8a]/10 aspect-[4/5] md:aspect-square max-w-md mx-auto" data-id="element-156">
              <img src="https://cdn.magicpatterns.com/uploads/mxaT4Gnc5UYZVDqmUN9CAd/imagen_meal_prep.png" alt="Meal Prep para Cerebro Saturado Ebook" className="w-full h-full object-cover" loading="eager" data-id="element-157" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}